import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgClass } from '@angular/common';
import { CdsIconModule } from '@cds/ng-web-components/icon';

@Component({
  selector: 'app-cd-inline-alert',
  templateUrl: './cd-inline-alert.component.html',
  styleUrls: ['./cd-inline-alert.component.scss'],
  imports: [NgClass, CdsIconModule],
})
export class CdInlineAlertComponent implements OnInit {
  @Input() type: 'error' | 'warning' = 'error';
  @Input() title?: string;
  @Input() text?: string;
  @Input() showCloseBtn = true;
  @Output() closeEvent = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  onClose() {
    this.closeEvent.emit();
  }
}
